import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYoutubemusicComponent } from './simple-icons-youtubemusic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYoutubemusicComponent ],
    exports:      [ SimpleIconsYoutubemusicComponent ],
    bootstrap:    []
})
export class SimpleIconsYoutubemusicModule {}
